import React, { createContext, useContext, useState } from 'react';

type UserContextType = {
  defaultMinBal: string;
  defaultRace: number;
  defaultBal: number;
  setDefaultMinBal: React.Dispatch<React.SetStateAction<string>>;
  setDefaultRace: React.Dispatch<React.SetStateAction<number>>;
  setDefaultBal: React.Dispatch<React.SetStateAction<number>>;
};

const UserContext = createContext<UserContextType>({
  defaultMinBal: '0',
  defaultRace: 0,
  defaultBal: 0,
  setDefaultMinBal: () => {},
  setDefaultRace: () => {},
  setDefaultBal: () => {},
});

export const useUserContext = () => useContext(UserContext);

type UserProviderProps = {
  children: React.ReactNode;
};

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [defaultMinBal, setDefaultMinBal] = useState('0');
  const [defaultRace, setDefaultRace] = useState(50);
  const [defaultBal, setDefaultBal] = useState(0);

  return (
    <UserContext.Provider
      value={{
        defaultMinBal,
        defaultRace,
        defaultBal,
        setDefaultMinBal,
        setDefaultRace,
        setDefaultBal,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

